// QA fix wave 2 / F6: shared onKeyDown handler for every native <select> in
// this tree (item-level piece/handling-unit-type/weight-uom/dim-uom
// selects, per-unit weight/dim-uom/status selects, the bulk-apply row's
// selects, and the kebab's swap-label select). Chrome does not open a
// native <select>'s option list on Enter the way it does on Space/click —
// only Chromium exposes HTMLSelectElement#showPicker for opening it
// programmatically, so this is guarded (not implemented in every engine,
// and can throw if called outside a user gesture in some of them) and is a
// silent no-op everywhere else, exactly like Enter already was before this
// handler existed. Once open, the browser's own up/down arrow handling
// takes over natively — nothing else to wire up.
export function openSelectOnEnter(e) {
  if (e.key !== "Enter") return;
  e.preventDefault();
  try {
    e.target.showPicker?.();
  } catch (err) {
    // no-op: unsupported/blocked in this engine
  }
}
